import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import {
    FETCH_PRODUCT_DISPATCH_SUCCESS, FETCH_PRODUCT_DISPATCH_FAILURE,
} from '../../redux/modules/productDispatch/productDispatch-actions';

export function* fetchProductDispatch(action) {
    try {
        const {
            api,
            page,
            size,
            searchConstruct,
        } = action;
        const apiWithParams = `${api}?page=${page}&size=${size}`;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.post, apiWithParams, searchConstruct);
        yield put({
            type: FETCH_PRODUCT_DISPATCH_SUCCESS,
            data: {
                ...(response.data || {}),
                page,
            },
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Product dispatch fetch failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: FETCH_PRODUCT_DISPATCH_FAILURE, data: {} });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export default fetchProductDispatch;
